import React, { useState } from "react";
import { managerContent as playerDexLogo } from "../assets/managerBranding";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../shadcn/components/ui/avatar";

// Club logo, or the PlayerDex logo when the club has none or it fails to load.
const ClubLogo = ({ club, size = 32 }) => {
  const [failedSource, setFailedSource] = useState(null);
  const logo = club?.logo?.trim();
  const showClubLogo = Boolean(logo && logo !== failedSource);
  const src = showClubLogo ? logo : playerDexLogo;

  return (
    <Avatar
      className="rounded-md after:hidden"
      style={{ width: size, height: size }}
    >
      <AvatarImage
        key={src}
        src={src}
        alt={showClubLogo ? club?.name || "Club" : "PlayerDex logo"}
        className="rounded-md object-contain"
        onLoadingStatusChange={(status) => {
          if (status === "error" && showClubLogo) setFailedSource(logo);
        }}
      />
      <AvatarFallback className="rounded-md">
        {(club?.name || "P").charAt(0)}
      </AvatarFallback>
    </Avatar>
  );
};

export default ClubLogo;
